var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-app": "" } },
    [
      _c(
        "v-dialog",
        {
          ref: "dialog",
          attrs: {
            "max-width": _vm.maxWidth,
            height: _vm.height,
            persistent: _vm.persistent,
            transition: _vm.isCentered
              ? null
              : _vm.shellCorner
              ? "dialog-bottom-transition"
              : "dialog-right-transition",
            "content-class":
              (_vm.isCentered ? "" : "default-right-dialog") +
              " " +
              _vm.contentClass,
            role: "dialog",
            "aria-modal": "true"
          },
          scopedSlots: _vm._u(
            [
              _vm.hasSlotButton()
                ? {
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on
                      return [
                        _c(
                          "BaseButton",
                          _vm._g({ attrs: { none: "" } }, on),
                          [_vm._t("button", null, { open: on })],
                          2
                        )
                      ]
                    }
                  }
                : null
            ],
            null,
            true
          ),
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { class: _vm.cardClasses, style: _vm.cardStyle },
            [
              _vm.shell
                ? [
                    _c("header", { staticClass: "base-modal__header" }, [
                      _c(
                        "div",
                        { staticClass: "base-modal__identity" },
                        [
                          _vm._t("header-identity", [
                            _vm._t("header-avatar"),
                            _c("div", { staticClass: "base-modal__heading" }, [
                              _c(
                                "div",
                                { staticClass: "base-modal__title" },
                                [_vm._t("title")],
                                2
                              ),
                              _vm.hasSlotSubtitle()
                                ? _c(
                                    "div",
                                    { staticClass: "base-modal__subtitle" },
                                    [_vm._t("subtitle")],
                                    2
                                  )
                                : _vm._e()
                            ])
                          ])
                        ],
                        2
                      ),
                      _vm.hasSlotHeaderAside()
                        ? _c(
                            "div",
                            { staticClass: "base-modal__header-aside" },
                            [_vm._t("header-aside")],
                            2
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "base-modal__header-actions" },
                        [
                          _vm._t("header-actions"),
                          !_vm.withoutCloseButton
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { icon: "", "aria-label": "Fechar" },
                                  on: { click: _vm.close }
                                },
                                [
                                  _c("icon-svg", {
                                    staticClass: "modal-close-button",
                                    attrs: {
                                      name: "close-circle",
                                      color: _vm.closeColor,
                                      size: _vm.shellCloseIconSize
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ]),
                    _c(
                      "section",
                      { staticClass: "base-modal__body" },
                      [
                        _vm.hasSlotMeta()
                          ? _c(
                              "div",
                              { staticClass: "base-modal__meta" },
                              [_vm._t("meta")],
                              2
                            )
                          : _vm._e(),
                        _vm.showContent ? _vm._t("default") : _vm._e()
                      ],
                      2
                    ),
                    _vm.hasFooter()
                      ? _c("footer", { staticClass: "base-modal__footer" }, [
                          _c(
                            "div",
                            { staticClass: "base-modal__footer-status" },
                            [
                              _vm._t("footer-status", [
                                _vm.requiredHint
                                  ? _c("span", { staticClass: "az-ds-aux" }, [
                                      _c(
                                        "span",
                                        { staticClass: "az-required-asterisk" },
                                        [_vm._v("*")]
                                      ),
                                      _vm._v(" Campos obrigatórios ")
                                    ])
                                  : _vm._e()
                              ])
                            ],
                            2
                          ),
                          _c(
                            "div",
                            { staticClass: "base-modal__footer-actions" },
                            [
                              _vm._t("actions", null, {
                                close: _vm.close,
                                setPrimaryAction: _vm.setPrimaryAction,
                                isPrimaryAction: _vm.isPrimaryAction
                              })
                            ],
                            2
                          )
                        ])
                      : _vm._e()
                  ]
                : [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex align-center",
                        class: {
                          "justify-content-between": _vm.hasTitle(),
                          "justify-content-end": !_vm.hasTitle()
                        },
                        style: {
                          padding: _vm.titleRowPadding
                        }
                      },
                      [
                        _vm._t("title"),
                        !_vm.withoutCloseButton
                          ? _c(
                              "v-btn",
                              {
                                attrs: {
                                  small: _vm.centerAndDecreasesPadding,
                                  icon: ""
                                },
                                on: { click: _vm.close }
                              },
                              [
                                _c("icon-svg", {
                                  staticClass: "modal-close-button",
                                  attrs: {
                                    name: "close-circle",
                                    color: _vm.closeColor,
                                    size: _vm.centerAndDecreasesPadding
                                      ? 22
                                      : 30
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm.fixedActions && _vm.showContent
                      ? _c(
                          "div",
                          { staticClass: "base-modal__content--scrollable" },
                          [_vm._t("default")],
                          2
                        )
                      : _vm._e(),
                    !_vm.fixedActions && _vm.showContent
                      ? _vm._t("default")
                      : _vm._e(),
                    _vm.fixedActions && _vm.hasSlotActions()
                      ? _c("v-divider", {
                          staticClass: "base-modal__actions-divider"
                        })
                      : _vm._e(),
                    _vm.hasSlotActions()
                      ? _c(
                          "v-card-actions",
                          {
                            staticClass: "modal-actions",
                            style: _vm.actionsStyle
                          },
                          [
                            _vm.requiredHint
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "base-modal__required-hint az-ds-aux"
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "az-required-asterisk" },
                                      [_vm._v("*")]
                                    ),
                                    _vm._v(" Campos obrigatórios ")
                                  ]
                                )
                              : _vm._e(),
                            _c("v-spacer"),
                            _vm._t("actions", null, { close: _vm.close }),
                            _vm.centerScreen ? _c("v-spacer") : _vm._e()
                          ],
                          2
                        )
                      : _vm._e()
                  ]
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }